import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";

import { Seo } from "components";
import { HomeView } from "views";

function IndexPage() {
  return <HomeView />;
}

export function Head() {
  const { prismicHomepage } = useStaticQuery(HOME_SEO_QUERY);
  const seo = prismicHomepage.data;
  return (
    <Seo
      title={seo.seo_title && seo.seo_title.text}
      description={seo.seo_description && seo.seo_description.text}
      imageOpenGraph={seo.seo_image && seo.seo_image.url}
      imageAlt={seo.seo_image && seo.seo_image.alt}
    />
  );
}

const HOME_SEO_QUERY = graphql`
  {
    prismicHomepage {
      data {
        seo_title {
          text
        }
        seo_description {
          text
        }
        seo_image {
          url
          alt
        }
      }
    }
  }
`;

// Wrapped to bootstrap the preview session on the homepage. IndexPage has no
// page query, so the HOC's data-merge is a no-op — but it triggers the preview
// fetch that HomeView's `useMergePrismicPreviewData` then merges into the
// `prismicHomepage` static query.
export default withPrismicPreview(IndexPage);
